import { Component, type ReactNode } from 'react';

/**
 * 범용 에러 경계 — lazy 청크 로드 실패·렌더/생명주기 오류를 잡아 fallback으로.
 * (비동기 RAF/이벤트 오류는 React 경계가 못 잡으니 그쪽은 호출부가 별도 신호로 처리.)
 */
export class ErrorBoundary extends Component<
  { fallback: ReactNode; children: ReactNode; onError?: () => void; resetKey?: string | number },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch() {
    this.props.onError?.();
  }
  componentDidUpdate(prev: { resetKey?: string | number }) {
    // resetKey(예: cityId) 변경 시 복구 — 한 대상의 오류가 다른 대상까지 영구 폴백하는 것 방지
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
